import _classCallCheck from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\classCallCheck.js";
import _createClass from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\createClass.js";
import _inherits from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\inherits.js";
import _possibleConstructorReturn from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\possibleConstructorReturn.js";
import _getPrototypeOf from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _excluded = ["direction", "children", "onTransitionEnd"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cn from 'classnames';
import transitionEnd from 'dom-helpers/transitionEnd';
import React from 'react';
var prefix = 'rw-calendar-transition';
var active = 'rw-calendar-transition-active';
var next = 'rw-calendar-transition-next';
var prev = 'rw-calendar-transition-prev';

var clone = function clone(el, cls) {
  return el && /*#__PURE__*/React.cloneElement(el, {
    className: cn(el.props.className, prefix, cls)
  });
};

var SlideTransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(SlideTransitionGroup, _React$Component);

  var _super = _createSuper(SlideTransitionGroup);

  function SlideTransitionGroup(args) {
    var _this;

    _classCallCheck(this, SlideTransitionGroup);

    _this = _super.call(this, args);

    _this.handleTransitionEnd = function (hadFocus) {
      _this.isTransitioning = false;
      var current = _this.container.current.lastChild;
      if (_this.props.onTransitionEnd) _this.props.onTransitionEnd(current, hadFocus);
    };

    _this.current = _this.props.children;
    _this.container = /*#__PURE__*/React.createRef();
    _this.state = {
      prevClasses: '',
      currentClasses: ''
    };
    return _this;
  }

  _createClass(SlideTransitionGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (!this.flush || this.isTransitioning) return;
      this.flush = false;
      this.isTransitioning = true;
      var previous = this.container.current.firstChild;
      var hadFocus = document.activeElement && previous.contains(document.activeElement);
      this.setState({
        prevClasses: '',
        currentClasses: next
      }, function () {
        var current = _this2.container.current.lastChild;
        current.clientHeight; // eslint-disable-line

        _this2.setState({
          prevClasses: prev,
          currentClasses: cn(next, active)
        }, function () {
          transitionEnd(current, function () {
            _this2.prev = null;

            if (_this2.current.key !== _this2.props.children.key) {
              _this2.current = _this2.props.children;
            }

            _this2.setState({
              prevClasses: '',
              currentClasses: ''
            }, function () {
              return _this2.handleTransitionEnd(hadFocus);
            });
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          direction = _this$props.direction,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

      if (!this.isTransitioning) {
        if (this.current.key !== children.key) {
          this.prev = this.current;
          this.flush = true;
        }

        this.current = children;
      }

      var _this$state = this.state,
          prevClasses = _this$state.prevClasses,
          currentClasses = _this$state.currentClasses;
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        ref: this.container,
        className: cn("rw-calendar-transition-group", direction === 'top' && 'rw-calendar-transition-top', direction === 'right' && 'rw-calendar-transition-right', direction === 'bottom' && 'rw-calendar-transition-bottom', direction === 'left' && 'rw-calendar-transition-left')
      }), clone(this.prev, prevClasses), clone(this.current, currentClasses));
    }
  }]);

  return SlideTransitionGroup;
}(React.Component);

SlideTransitionGroup.defaultProps = {
  direction: 'left'
};
export default SlideTransitionGroup;